import i18n from "i18next";
import store from "store/configureStore";
import { setErrorMessage, setBlockedMessage } from "store/actions/common/common.actions";
import { ERROR_STATUSES } from "constants/message.constants";

/** Show error notification
 * @function
 * @param {string} msg - error message
 * @param {string} status - error status
 * @param {string} resource - error resource
 */

export const showError = (msg, status, resource) => {
	if ((status === ERROR_STATUSES.NOT_ALLOWED && ["Player", "Player_GeoLocation"].includes(resource)) || (status === ERROR_STATUSES.INVALID_PARAMETERS && resource === "Player_GeoLocation") || msg === "InvalidPlayedData") {
		return store.dispatch(setBlockedMessage("errors.message.Blocked"));
	} else if (status === ERROR_STATUSES.NOT_ALLOWED && resource === "Session" && (msg === "NotSupportedCurency" || msg === "InvalidPlayerCurrency")) {
		return store.dispatch(setBlockedMessage("errors.message.CurencyBlocked"));
	} else if (status === ERROR_STATUSES.NOT_ALLOWED && resource === "Player_Device" && msg === "Blocked") {
		return store.dispatch(setBlockedMessage("errors.message.DeviceBlocked"));
	} else if (status === ERROR_STATUSES.NOT_ALLOWED && resource === "Player_Browser" && msg === "Blocked") {
		return store.dispatch(setBlockedMessage("errors.message.DeviceNotSupported"));
	} else if (status === ERROR_STATUSES.INVALID_PARAMETERS && resource === "Custom" && typeof msg === "string") {
		try {
			const parsedMsg = JSON.parse(msg);
			const {
				messageKey,
				parameters: { minAmount, maxAmount }
			} = parsedMsg;
			store.dispatch(setErrorMessage(i18n.t(`errors.message.${messageKey}`).replace("%minAmount%", minAmount).replace("%maxAmount%", maxAmount)));
		} catch (error) {
			console.error(error);
		}
		return;
	}

	if (!status) return store.dispatch(setErrorMessage(msg));
	let text = i18n.t(`errors.message.${status}`);
	let res = resource && resource !== "None" ? i18n.t(`errors.resources.${resource}`) : "";

	if (text) {
		text = text.replace("%resource%", res);
	}
	text = text || "";

	if (status === ERROR_STATUSES.INVALID_PARAMETERS && resource === "Operator") {
		if (msg !== "Player does not have enough funds to process an action.") {
			text = i18n.t(`errors.message.${msg}`);
		} else {
			text = i18n.t("errors.message.NotEnoughBalance");
		}
	}
	store.dispatch(setErrorMessage(text));
};
